module.exports = __webpack_public_path__ + "static/media/John_B.afd3a62c.jpg";